import { render, staticRenderFns } from "./registerBox.vue?vue&type=template&id=48837ead&scoped=true&"
import script from "./registerBox.vue?vue&type=script&lang=js&"
export * from "./registerBox.vue?vue&type=script&lang=js&"
import style0 from "./registerBox.vue?vue&type=style&index=0&id=48837ead&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48837ead",
  null
  
)

export default component.exports